// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ReservationsTable_reservations__Dpl06 {
  width: 100%;
  font-family: "Sora", sans-serif;
  display: flex;
  flex-direction: column;
}
.ReservationsTable_reservations__table__3j6RW {
  border-radius: 20px;
  overflow: hidden;
}
.ReservationsTable_reservations__header__dEWRo {
  margin-bottom: 32px;
  text-align: left;
}
.ReservationsTable_reservations__eyebrow__o7k5z {
  display: block;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #82B194;
  margin-bottom: 8px;
}
.ReservationsTable_reservations__title__M7lQb {
  margin: 0;
  font-size: 32px;
  font-weight: 800;
  color: #13231D;
  letter-spacing: -0.03em;
}
.ReservationsTable_reservations__filters__ljyTt {
  margin-bottom: 0px;
}

.ReservationsTable_cell-name__GR9ai {
  font-weight: 700;
  color: #13231D;
  font-size: 15px;
}

.ReservationsTable_cell-date__ngBb6 {
  display: flex;
  flex-direction: column;
}
.ReservationsTable_cell-date__ngBb6 strong {
  font-size: 14px;
  color: #13231D;
}
.ReservationsTable_cell-date__ngBb6 span {
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 600;
}

.ReservationsTable_cell-reason__p6RM- {
  margin: 0;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  max-width: 250px;
  line-height: 1.4;
}

.ReservationsTable_menu-btn__-Qv8h {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: transparent;
  border: none;
  border-radius: 10px;
  font-family: "Sora", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #13231D;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
}
.ReservationsTable_menu-btn__-Qv8h:hover {
  background-color: rgba(130, 177, 148, 0.08);
  color: #82B194;
}
.ReservationsTable_menu-btn__-Qv8h svg {
  color: rgba(19, 35, 29, 0.68);
}
.ReservationsTable_menu-btn--highlight__s2K42 {
  color: #8a6516;
  background-color: rgba(214, 166, 64, 0.08);
}
.ReservationsTable_menu-btn--highlight__s2K42:hover {
  background-color: rgba(214, 166, 64, 0.15);
  color: #8a6516;
}
.ReservationsTable_menu-btn--highlight__s2K42 svg {
  color: #d6a640;
}

.ReservationsTable_text-muted__yQHmi {
  opacity: 0.5;
}

@media (max-width: 1200px) {
  .ReservationsTable_reservations__title__M7lQb {
    font-size: 28px;
  }
  .ReservationsTable_reservations__filters__ljyTt {
    margin-bottom: 24px;
  }
  .ReservationsTable_cell-name__GR9ai {
    font-size: 14px;
  }
  .ReservationsTable_cell-date__ngBb6 strong {
    font-size: 13px;
  }
  .ReservationsTable_cell-reason__p6RM- {
    font-size: 13px;
    max-width: 200px;
  }
}
@media (max-width: 992px) {
  .ReservationsTable_reservations__title__M7lQb {
    font-size: 26px;
  }
  .ReservationsTable_reservations__header__dEWRo {
    margin-bottom: 24px;
  }
  .ReservationsTable_cell-reason__p6RM- {
    max-width: 150px;
  }
}
@media (max-width: 768px) {
  .ReservationsTable_reservations__title__M7lQb {
    font-size: 24px;
  }
  .ReservationsTable_reservations__header__dEWRo {
    margin-bottom: 20px;
    padding: 0 4px;
  }
  .ReservationsTable_reservations__filters__ljyTt {
    margin-bottom: 8px;
  }
  .ReservationsTable_reservations__table__3j6RW {
    border-radius: 0;
    margin: 0 -10px;
  }
  .ReservationsTable_cell-name__GR9ai, .ReservationsTable_cell-date__ngBb6, .ReservationsTable_cell-reason__p6RM- {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    max-width: 100%;
  }
  .ReservationsTable_cell-name__GR9ai {
    font-size: 15px;
  }
  .ReservationsTable_cell-date__ngBb6 strong {
    font-size: 14px;
  }
  .ReservationsTable_cell-date__ngBb6 span {
    font-size: 12px;
  }
  .ReservationsTable_cell-reason__p6RM- {
    font-size: 13px;
    line-height: 1.3;
    max-width: 100%;
  }
}
@media (max-width: 480px) {
  .ReservationsTable_reservations__title__M7lQb {
    font-size: 22px;
  }
  .ReservationsTable_cell-name__GR9ai {
    font-size: 11px;
  }
  .ReservationsTable_cell-date__ngBb6 strong {
    font-size: 11px;
  }
  .ReservationsTable_cell-date__ngBb6 span {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ReservationsTable/ReservationsTable.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AATA;EACE,WAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;AAYF;AAVE;EACE,mBAAA;EACA,gBAAA;AAYJ;AATE;EACE,mBAAA;EACA,gBAAA;AAWJ;AARE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDlBmB;ECmBnB,kBAAA;AAUJ;AAPE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDbmB;ECcnB,uBAAA;AASJ;AANE;EACE,kBAAA;AAQJ;;AAHA;EACI,gBAAA;EACA,cDzBmB;EC0BnB,eAAA;AAMJ;;AAHA;EACI,aAAA;EACA,sBAAA;AAMJ;AAJI;EAAS,eAAA;EAAiB,cDjCP;ACyCvB;AAPI;EAAO,eAAA;EAAiB,6BDhCL;ECgCuB,gBAAA;AAY9C;;AATA;EACI,SAAA;EACA,eAAA;EACA,6BDtCmB;ECuCnB,gBAAA;EACA,gBAAA;AAYJ;;AATA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,cDzDmB;EC0DnB,eAAA;EACA,gBAAA;EACA,yBAAA;AAYJ;AAVI;EACI,2CAAA;EACA,cD7Ee;ACyFvB;AATI;EACI,6BDlEe;AC6EvB;AARI;EACI,cAAA;EACA,0CAAA;AAUR;AARQ;EACI,0CAAA;EACA,cAAA;AAUZ;AAPQ;EAAM,cAAA;AAUd;;AANA;EACI,YAAA;AASJ;;AANA;EAEI;IAAW,eAAA;EASb;EAPE;IACE,mBAAA;EASJ;EALA;IAAa,eAAA;EAQb;EAPA;IAAoB,eAAA;EAUpB;EATA;IAAe,eAAA;IAAiB,gBAAA;EAahC;AACF;AAXA;EAEI;IAAW,eAAA;EAab;EAZE;IAAY,mBAAA;EAed;EAZA;IACE,gBAAA;EAcF;AACF;AAXA;EAEI;IAAW,eAAA;EAab;EAZE;IACI,mBAAA;IACA,cAAA;EAcN;EAZE;IACI,kBAAA;EAcN;EAXE;IACI,gBAAA;IACA,eAAA;EAaN;EATA;IACI,aAAA;IACA,sBAAA;IACA,qBAAA;IACA,iBAAA;IACA,eAAA;EAWJ;EARA;IACI,eAAA;EAUJ;EANI;IAAS,eAAA;EASb;EARI;IAAO,eAAA;EAWX;EARA;IACI,eAAA;IACA,gBAAA;IACA,eAAA;EAUJ;AACF;AAPA;EAEQ;IAAW,eAAA;EASjB;EANE;IACI,eAAA;EAQN;EAJM;IAAS,eAAA;EAOf;EANM;IAAO,eAAA;EASb;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-border:$color-border;\n\n.reservations {\n  width: 100%;\n  font-family: \"Sora\", sans-serif;\n  display: flex;\n  flex-direction: column;\n\n  &__table {\n    border-radius: 20px;\n    overflow: hidden;\n  }\n\n  &__header {\n    margin-bottom: 32px;\n    text-align: left;\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: 11px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.14em;\n    color: $bw-primary;\n    margin-bottom: 8px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 32px;\n    font-weight: 800;\n    color: $bw-text;\n    letter-spacing: -0.03em;\n  }\n\n  &__filters {\n    margin-bottom: 0px;\n  }\n}\n\n\n.cell-name {\n    font-weight: 700;\n    color: $bw-text;\n    font-size: 15px;\n}\n\n.cell-date {\n    display: flex;\n    flex-direction: column;\n    \n    strong { font-size: 14px; color: $bw-text; }\n    span { font-size: 12px; color: $bw-muted; font-weight: 600; }\n}\n\n.cell-reason {\n    margin: 0;\n    font-size: 14px;\n    color: $bw-muted;\n    max-width: 250px;\n    line-height: 1.4;\n}\n\n.menu-btn {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    background: transparent;\n    border: none;\n    border-radius: 10px;\n    font-family: \"Sora\", sans-serif;\n    font-size: 13px;\n    font-weight: 600;\n    color: $bw-text;\n    cursor: pointer;\n    text-align: left;\n    transition: all 0.2s ease;\n\n    &:hover {\n        background-color: rgba(130, 177, 148, 0.08);\n        color: $bw-primary;\n    }\n\n    svg {\n        color: $bw-muted;\n    }\n\n    &--highlight {\n        color: #8a6516;\n        background-color: rgba(214, 166, 64, 0.08);\n        \n        &:hover {\n            background-color: rgba(214, 166, 64, 0.15);\n            color: #8a6516;\n        }\n\n        svg { color: #d6a640; }\n    }\n}\n\n.text-muted {\n    opacity: 0.5;\n}\n\n@media (max-width: 1200px) {\n  .reservations {\n    &__title { font-size: 28px; }\n    \n    &__filters {\n      margin-bottom: 24px;\n    }\n  }\n\n  .cell-name { font-size: 14px; }\n  .cell-date strong { font-size: 13px; }\n  .cell-reason { font-size: 13px; max-width: 200px; }\n}\n\n@media (max-width: 992px) {\n  .reservations {\n    &__title { font-size: 26px; }\n    &__header { margin-bottom: 24px; }\n  }\n\n  .cell-reason {\n    max-width: 150px;\n  }\n}\n\n@media (max-width: 768px) {\n  .reservations {\n    &__title { font-size: 24px; }\n    &__header { \n        margin-bottom: 20px; \n        padding: 0 4px;\n    }\n    &__filters { \n        margin-bottom: 8px; \n    }\n    \n    &__table {\n        border-radius: 0;\n        margin: 0 -10px; // Slight negative margin to take more space if needed\n    }\n  }\n\n  .cell-name, .cell-date, .cell-reason {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      text-align: right;\n      max-width: 100%;\n  }\n\n  .cell-name {\n      font-size: 15px;\n  }\n\n  .cell-date {\n      strong { font-size: 14px; }\n      span { font-size: 12px; }\n  }\n\n  .cell-reason {\n      font-size: 13px;\n      line-height: 1.3;\n      max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n    .reservations {\n        &__title { font-size: 22px; }\n    }\n\n    .cell-name {\n        font-size: 11px;\n    }\n\n    .cell-date {\n        strong { font-size: 11px; }\n        span { font-size: 11px; }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reservations": `ReservationsTable_reservations__Dpl06`,
	"reservations__table": `ReservationsTable_reservations__table__3j6RW`,
	"reservations__header": `ReservationsTable_reservations__header__dEWRo`,
	"reservations__eyebrow": `ReservationsTable_reservations__eyebrow__o7k5z`,
	"reservations__title": `ReservationsTable_reservations__title__M7lQb`,
	"reservations__filters": `ReservationsTable_reservations__filters__ljyTt`,
	"cell-name": `ReservationsTable_cell-name__GR9ai`,
	"cell-date": `ReservationsTable_cell-date__ngBb6`,
	"cell-reason": `ReservationsTable_cell-reason__p6RM-`,
	"menu-btn": `ReservationsTable_menu-btn__-Qv8h`,
	"menu-btn--highlight": `ReservationsTable_menu-btn--highlight__s2K42`,
	"text-muted": `ReservationsTable_text-muted__yQHmi`
};
export default ___CSS_LOADER_EXPORT___;
